import getDisplayName from './getDisplayName';

/**
 * @param {string|function} component
 * @param {string} [name='HOC']
 * @returns {string}
 */
function wrapDisplayName(component) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HOC';

  return name + '(' + getDisplayName(component) + ')';
}

export default wrapDisplayName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/wrapDisplayName.js
// module id = 776
// module chunks = 0